var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMyProfileinline = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16 2c7.728 0 14 6.272 14 14s-6.272 14-14 14S2 23.728 2 16 8.272 2 16 2zm.5 15c-2.833 0-8.457 1.557-8.5 4.4 1.828 2.771 4.958 4.6 8.5 4.6s6.672-1.829 8.5-4.6c-.043-2.843-5.68-4.4-8.5-4.4zM16 6c-2.213 0-4 1.787-4 4s1.787 4 4 4 4-1.787 4-4-1.787-4-4-4z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMyProfileinline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/my-profile.inline.33d9298fbeac666bcb06370c3a8e6eed.svg";